import React from 'react';
import { useTranslations } from 'use-intl';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { isErpConnectionEnabled } from "@/config/features";

interface WelcomeModalProps {
  isOpen: boolean;
  companyName: string;
  onContinueToSetup: () => void;
  onClose: () => void;
}

export function WelcomeModal({ isOpen, companyName, onContinueToSetup, onClose }: WelcomeModalProps) {
  const t = useTranslations('consultantOnboarding.welcome');
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-md"
        hideCloseButton={false}
        onEscapeKeyDown={undefined}
        onPointerDownOutside={undefined}
      >
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-center">
            {t('title')}
          </DialogTitle>
          <DialogDescription className="text-center pt-4 text-base">
            {t('body', { companyName })}
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center pt-6">
          <Button
            onClick={onContinueToSetup}
            className="px-8"
          >
            {isErpConnectionEnabled() ? t('continueErp') : t('continue')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
